export * from './reportPirate.args'
